// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3YdLC","author":"Table_author__1DN6n","authorImage":"Table_authorImage__2v-px","unreadRow":"Table_unreadRow__HqA31"};